export default {
  footer: {
    aboutDfuse: "中数文联盟链区块浏览器",
    copyright: "© {{year}} 中数文科技有限公司",
    privacyPolicy: "隐私政策",
    privacyPolicyLink: "https://zhongshuwen.com/help-block-explorer",
    termsOfServices: "服务条款",
    termsOfServicesLink: "https://zhongshuwen.com/help-block-explorer-terms"
  }
}
